export enum ApprovalPeriodType {
    Hour = 1,
    Day = 2, 
}